var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgToastInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7586 6.66699V25.3337C25.7586 26.8064 24.5647 28.0003 23.092 28.0003H8.42529C8.42529 29.4731 9.6192 30.667 11.092 30.667H23.092C26.0375 30.667 28.4253 28.2792 28.4253 25.3337V9.33366C28.4253 7.8609 27.2314 6.66699 25.7586 6.66699Z",
    fill: "black",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.092 3.99968V22.6663C23.092 24.1391 21.8981 25.333 20.4254 25.333H5.75871C4.28595 25.333 3.09204 24.1391 3.09204 22.6663V10.4397C3.09148 9.72895 3.37466 9.0474 3.87871 8.54634L10.3054 2.11968C10.8064 1.61562 11.488 1.33245 12.1987 1.33301H20.4254C21.8981 1.33301 23.092 2.52692 23.092 3.99968ZM11.092 10.6663C11.8284 10.6663 12.4254 10.0694 12.4254 9.33301V3.75968L5.51871 10.6663H11.092Z",
    fill: "black",
    fillOpacity: 0.7
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgToastInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ToastInfo.8f9615d2.svg";
export { ForwardRef as ReactComponent };